module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications"
  }, [_c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.notifications), function(notification, index) {
    return _c('notification', {
      key: notification.timestamp.getTime(),
      attrs: {
        "message": notification.message,
        "icon": notification.icon,
        "type": notification.type,
        "timestamp": notification.timestamp,
        "vertical-align": notification.verticalAlign,
        "horizontal-align": notification.horizontalAlign
      },
      on: {
        "on-close": _vm.removeNotification
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e7276f2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/NotificationPlugin/Notifications.vue
// module id = 177
// module chunks = 2